<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            <!-- {{ $t('company.vision.title') }} -->
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('itSolutions.service.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            <!-- {{ $t('rubin.introduction')}} -->
          </v-col>
        </v-row>
        <v-row class="justify-center">

          <!-- TODO rename classes -->
          <div class="grid-container">
          <!-- competence -->
          <div class="grid-box-2 gridyhe-1">
            <v-img class="gr-img" src="@/assets/img/it-service-01.webp">&nbsp;</v-img>
            <div class="gr-info">
              <h3>{{ $t("itSolutions.service.breef.01.title") }}</h3>
              <p class="gr-text">{{ $t("itSolutions.service.breef.01.text") }}</p>
            </div>
          </div>
          <!-- quality -->
          <div class="grid-box-1 gridyhe-1">
            <v-img class="gr-img" src="@/assets/img/it-service-02.webp">&nbsp;</v-img>
            <div class="gr-info">
              <h3>{{ $t("itSolutions.service.breef.03.title") }}</h3>
              <p class="gr-text">{{ $t("itSolutions.service.breef.03.text") }}</p>
            </div>
          </div>
          <!-- process -->
          <div class="grid-box-1 gridyhe-2">
            <v-img class="gr-img" src="@/assets/img/it-service-03.webp">&nbsp;</v-img>
            <div class="gr-info">
              <h3>{{ $t("itSolutions.service.breef.04.title") }}</h3>
              <p class="gr-text">{{ $t("itSolutions.service.breef.04.text") }}</p>
            </div>
          </div>
          <!-- modular softwares -->
          <div class="grid-box-2 gridyhe-1">
            <v-img class="gr-img" src="@/assets/img/it-service-04.webp">&nbsp;</v-img>
            <div class="gr-info">
              <h3>{{ $t("itSolutions.service.breef.02.title") }}</h3>
              <p class="gr-text">{{ $t("itSolutions.service.breef.02.text") }}</p>
            </div>
          </div>
          <!-- testing -->
          <div class="grid-box-1 gridyhe-1">
            <div class="gr-img" style="background:#252525">&nbsp;</div>
            <div class="gr-info">
              <h3>{{ $t("itSolutions.service.breef.05.title") }}</h3>
              <p class="gr-text">{{ $t("itSolutions.service.breef.05.text") }}</p>
            </div>
          </div>
          <!-- support -->
          <div class="grid-box-1 gridyhe-1">
            <v-img class="gr-img" src="@/assets/img/it-service-06.webp">&nbsp;</v-img>
            <div class="gr-info">
              <h3>{{ $t("itSolutions.service.breef.06.title") }}</h3>
              <p class="gr-text">{{ $t("itSolutions.service.breef.06.text") }}</p>
            </div>
          </div>
        </div>

        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'ItService',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
